import { render, staticRenderFns } from "./ExperimentTitle.vue?vue&type=template&id=0799fc95&scoped=true&"
import script from "./ExperimentTitle.vue?vue&type=script&lang=js&"
export * from "./ExperimentTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0799fc95",
  null
  
)

export default component.exports